// import React, { useState } from 'react'
import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './NavigationTabs.styles'

/**
 * functional container for all detail views
 * @returns {*}
 * @constructor
 */
const NavigationTabs = ({
  items,
  selectedId,
  onSelect = () => {},
  ...rest
}) => {
  // const [selected, setSelected] = useState(selectedId)

  const handleTabClick = (id) => {
    // setSelected(id)
    onSelect(id)
  }

  return (
    <Styled.NavigationTabsComponent { ...rest }>
      <ul className='tabs-list' role='tablist'>
        {items &&
          items.map((item, index) => (
            <li
              key={ index }
              onClick={ () => handleTabClick(item.id) }
              className={ `tabs-list-item${
                item.id === selectedId ? ' active' : ''
              }` }>
              {/* className={ `tabs-list-item${ item.id === selected ? ' active' : '' }` }>*/}
              {item.label}
            </li>
          ))}
      </ul>
    </Styled.NavigationTabsComponent>
  )
}

NavigationTabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.exact({
      id: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  selectedId: PropTypes.string,
  onSelect: PropTypes.func,
}

export default NavigationTabs
